export default "__VITE_ASSET__DWE1Qf5T__"